<template lang="pug">
  Layout
    FormWrapper(type="password")
      template(v-slot:default="props")
        PasswordForm(
          :model="props.model",
          :redirect-route="{ name: 'editUser', params: { id: $route.params.id } }",
          :submit-fn="submitFn",
          :validate="props.validate",
          :valid="props.valid",
        )
</template>

<script>
import { mergeRight } from 'ramda';
import FormWrapper from '@/components/wrapper/FormWrapper.vue';
import Layout from '@/layouts/User.vue';
import PasswordForm from '@/components/forms/Password.vue';

export default {
  components: {
    FormWrapper,
    Layout,
    PasswordForm,
  },

  methods: {
    submitFn(payload) {
      return this.$store.dispatch(
        'user/updatePassword',
        mergeRight(payload, { id: this.$route.params.id }),
        {
          root: true,
        },
      );
    },
  },
};
</script>
